/**
 * @file コンポーネント：プライバシーポリシー日本語 ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const PrivacypolicyJapanese = () => {
    // Presenterに渡す
    return <Presenter />;
};
